module.exports = __webpack_public_path__ + "img/9_34.c872a2f3.png";